// @ts-nocheck
import React from 'react';
import { View, Text, StyleSheet, Pressable } from 'react-native';
import { theme } from '@/constants/theme';

type Props = {
  onPress?: () => void;
  style?: any;
};

export function BetaBanner({ onPress, style }: Props) {
  const Container: any = onPress ? Pressable : View;

  return (
    <Container
      onPress={onPress}
      style={[styles.wrap, style]}
      accessibilityRole={onPress ? 'button' : undefined}
    >
      <Text style={styles.badge}>BETA</Text>
      <Text style={styles.text}>זה מוצר בבטא — נשמח לפידבק</Text>
    </Container>
  );
}

const styles = StyleSheet.create({
  wrap: {
    width: '100%',
    paddingVertical: 10,
    paddingHorizontal: 12,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: theme.colors.border,
    backgroundColor: theme.colors.card,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  badge: {
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 999,
    overflow: 'hidden',
    backgroundColor: theme.colors.primary,
    color: '#fff',
    fontWeight: '800',
    fontSize: 12,
    letterSpacing: 0.6,
  },
  text: {
    flex: 1,
    color: theme.colors.text,
    fontSize: 13,
    fontWeight: '600',
  },
});